import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import Role from './Role';

class RoleAssignment extends DomainObject {
  id;
  role;

  _relations = {
    role: Role
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      role: observable
    });

    this.merge(other);
  }
}

export default RoleAssignment;
